import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import InputAreaPrice from "components/form/InputAreaPrice";
import InputName from "components/form/InputName";

import useItineraryBasicMarginUpdateSubmit from "hooks/useItineraryBasicMarginUpdateSubmit";

const ItineraryBasicMarginDrawer = ({ id }) => {
  const {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    loading,
    errors,
    marginData,
  } = useItineraryBasicMarginUpdateSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title
          register={register}
          title="Edit Basic Margin"
        />
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card
          className="flex-grow w-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 pb-20">

                <div className="grid grid-cols-12 gap-5 mb-8">

                  <div className="col-span-12">
                    <LabelArea
                      label="City"
                    />

                    <InputName
                      register={register}
                      name="city_name"
                      type="text"
                      disabled
                    />

                    <Error errorName={errors.cityname} />
                  </div>

                </div>

                <div className="grid grid-cols-12 gap-5">

                  {marginData?.margin_details &&
                    Object.entries(marginData.margin_details).map(([vehicleId, vehicle]) => (
                      <div className="col-span-6" key={vehicleId}>
                        <LabelArea
                          required
                          label={`${vehicle.name} Margin (%)`}
                        />

                        <InputAreaPrice
                          trigger={trigger}
                          register={register}
                          name={`margin.${vehicleId}`}
                          type="text"
                          maxLength={3}
                          placeholder={`Enter ${vehicle.name} Margin`}
                          onChangeFunction={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            if (value === "") {
                              e.target.value = "";
                              return;
                            }
                            value = Number(value);
                            if (value > 100) {
                              value = 100;
                            } else if (value < 0 && value.toString().length >= 2) {
                              value = 0;
                            }
                            e.target.value = value;
                          }}
                        />

                        <Error errorName={errors?.margin?.[vehicleId]} />
                      </div>
                    ))}

                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title="Update"
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default ItineraryBasicMarginDrawer;